/* Toon direct de juiste foto zodra een kleur wordt gekozen, ook als er nog geen maat is gekozen */
document.addEventListener('click', function (e) {
  var b = e.target.closest('.dgs-pdp__opt [data-val]');
  if (!b) return;
  var fs = b.closest('.dgs-pdp__opt');
  if (fs.classList.contains('dgs-pdp__opt--size')) return;
  var root = b.closest('.dgs-pdp');
  if (!root) return;
  var i = parseInt(fs.dataset.opt, 10);
  var data = root.querySelector('[data-variants]');
  if (!data) return;
  var variants = JSON.parse(data.textContent);
  var v = variants.find(function (x) { return x.options[i] === b.dataset.val && x.media; });
  if (!v) return;
  var slides = root.querySelector('[data-slides]');
  if (!slides) return;
  var el = slides.querySelector('[data-media-id="' + v.media + '"]');
  if (!el) return;
  var first = slides.firstElementChild;
  var left = el.offsetLeft - (first ? first.offsetLeft : 0);
  slides.style.scrollSnapType = 'none';
  slides.scrollLeft = left;
  requestAnimationFrame(function () { slides.style.scrollSnapType = ''; });
  var idx = Array.prototype.indexOf.call(slides.children, el);
  root.querySelectorAll('[data-thumb]').forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
});
